import styled from 'styled-components'

export const DatInput = styled.input`
  width: 100%;
  min-width: 0;
  min-height: 34px;
  padding: 7px 10px;
  margin: 0;
  appearance: none;
  background: rgba(2, 6, 23, 0.46);
  border: 1px solid rgba(148, 163, 184, 0.14);
  border-radius: 11px;
  outline: none;
  font-size: 0.86rem;
  color: #e2e8f0;
  transition:
    border-color 160ms ease,
    background 160ms ease,
    box-shadow 160ms ease;

  &:hover {
    background: rgba(2, 6, 23, 0.58);
    border-color: rgba(148, 163, 184, 0.18);
  }

  &:focus-visible {
    border-color: rgba(147, 197, 253, 0.24);
    box-shadow: 0 0 0 2px rgba(96, 165, 250, 0.08);
  }

  &:disabled {
    opacity: 0.58;
    cursor: not-allowed;
  }
`
